<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2">
            <div class="d-row d-flex align-items-center">

               <div class="ms-2 col-4 button-container">
                  <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm" data-bs-toggle="modal"
                     data-bs-target="#finalize-generate-api-key-modal" style="font-size: 15px; width: 200px;">
                     <i class="fa-regular fa-gears"></i>
                     &nbsp;Generate API Key
                  </button>
               </div>


               <div class="col-4">

               </div>

            </div>
         </div>

         <div class="row p-2">
            <div class="table-responsive">
               <table class="table align-middle">

                  <thead class="align-middle">
                     <tr>
                        <th scope="col" v-for="header in headers" :key="header.value">{{ header.text }}</th>
                     </tr>
                  </thead>

                  <tbody>
                     <tr v-for="(api_key, index) in api_keys" :key="index">
                        <td style="max-width: 100px;">{{ api_key.api_key }}
                           <input type="hidden" :id="'id_' + api_key.api_key" :value="api_key.api_key">
                        </td>
                        <td>
                           <button type="button" class="btn btn-circle" title="Copy API Key"
                              @click="CopyAPIKey(api_key.api_key)"><span><i class="fa-solid fa-copy"></i></span></button>
                        </td>
                        <td style="max-width: 100px;">
                           {{ formatDate(api_key.date_created) }}
                        </td>
                        <td>
                           <div v-if="api_key.is_disabled == 1" :style="{ color: '#EB1C24' }">
                              Disabled
                           </div>

                           <div v-if="api_key.is_disabled == 0" :style="{ color: '#00A36C' }">
                              Enabled
                           </div>
                        </td>
                        <td>
                           <div class="button-container">

                              <button v-if="api_key.is_disabled == 0" type="button" class="btn btn-circle-cancel"
                                 title="Disable API Key" @click="disableApiKey(api_key)"><span><i
                                       class="fa-solid fa-ban"></i></span></button>

                              <button v-if="api_key.is_disabled == 1" type="button" class="btn btn-circle-enable"
                                 title="Enable API Key" @click="enableApiKey(api_key)"><span><i
                                       class="fa-solid fa-cloud-bolt"></i></span></button>

                              <button type="button" class="btn btn-circle-trash" @click="deleteApiKey(api_key.id)"><span><i
                                       class="fa fa-trash"></i></span></button>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>

            </div>
         </div>

      </div>
   </div>


   <!-- Modal -->
   <div class="modal fade bg-blur" style="min-width: 400px;" id="finalize-generate-api-key-modal" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="finalize-generate-api-key-modal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content rounded-0" style="min-width: 400px;">

            <!-- Modal Header -->
            <div class="modal-header rounded-0" style="background-color:#00A0C1; min-width: 400px;">
               <h3 class="modal-title text-white">Generate Account API Key</h3>
               <button type="button " class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>


            <!-- Modal body -->
            <div class="modal-body" style="min-width: 400px;">
               <h5>Are you sure you want to generate an Account API Key?</h5>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="min-width: 400px;">
               <!-- <button type="button" class="btn btn-sm btn-outline-danger" data-bs-dismiss="modal">Cancel</button> -->
               <button type="button" class="btn btn-md btn-outline-verify" data-bs-dismiss="modal"
                  @click="generateAccountAPIKey()"> <i class="fa-regular fa-gears"></i> Generate</button>
            </div>

         </div>
      </div>
   </div>
   <!-- End Modal -->
</template>
 
<script>
import moment from 'moment'
export default {

   components: {
   },

   data() {
      return {
         headers: [
            { text: "API Key", value: "api_key" },
            { text: "", value: "" },
            { text: "Date Generated", value: "date_created" },
            { text: "Status", value: "status" },
            { text: "Action", value: "action" },
         ],
         api_keys: [],
      };

   },

   mounted() {
      this.init();
   },

   methods: {
      init() {
         this.getAccountApiKeys()
      },

      formatDate(date) {
         return moment(date).format("DD-MMM-YYYY @ HH:mm:ss")
      },

      async getAccountApiKeys() {
         await this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-api-keys")
            .then((response) => {
               this.api_keys = response.data.api_keys
            })
            .catch((error) => {
               console.log(error)
               this.$toast.error(error.response.data.message)
            })
      },

      CopyAPIKey(api_key) {
         let testingCodeToCopy = document.querySelector(`#id_${api_key}`)
         testingCodeToCopy.setAttribute('type', 'text')
         testingCodeToCopy.select()
         document.execCommand('copy');
         testingCodeToCopy.setAttribute('type', 'hidden')
         window.getSelection().removeAllRanges()
         this.$toast.success(`${api_key} copied to clipboard.`)
      },

      async generateAccountAPIKey() {
         try {

            const payload = {

            }

            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/generate-account-api-key", payload)

            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getAccountApiKeys()
            }

         } catch (error) {
            console.log(error)
            this.$toast.error("An error has occured.")
            // this.$toast.error(error.response.data.message)
         }
      },

      async disableApiKey(api_key) {
         try {

            const payload = {
               is_disabled: 1,
               id: api_key.id
            }

            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/change-account-api-key-activeness", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getAccountApiKeys()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error("An error has occured.")
            // this.$toast.error(error.response.data.message)
         }
      },

      async enableApiKey(api_key) {
         try {
            const payload = {
               is_disabled: 0,
               id: api_key.id
            }

            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/change-account-api-key-activeness", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getAccountApiKeys()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error("An error has occured.")
            // this.$toast.error(error.response.data.message)
         }
      },

      async deleteApiKey(id) {
         try {
            const payload = {
               id: id
            }
            const resp = await this.$axios.delete("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/remove-account-api-key/" + id, payload)

            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getAccountApiKeys()
            }

         } catch (error) {
            console.log(error)
            this.$toast.error("An error has occured.")
            // this.$toast.error(error.response.data.message)
         }
      },
   }
}

</script>
 
<style scoped>
.card {
   border: none;
}

.card-title {
   font-style: normal;
   font-weight: 400;
   font-size: 20px;
   color: #435666;
}

.table {
   border: 0px 0px 1px 0px;
   font-size: 15px
}

.button-container {
   display: flex;
   gap: 15px;
   /* Adjust this value for the desired spacing */
}


/* additional styles */

/* button {
    border-radius: 40px !important;
 } */

.btn-info {
   background-color: #00a0c1;
   border-color: #00a0c1;
}

.btn-info-outline {
   background-color: white;
   border-color: #00a0c1;
   color: #00a0c1;
}

.btn-outline-verify {
   background-color: white;
   border-color: #00a0c1;
   color: #00a0c1
}

.btn-outline-verify:hover {
   color: #fff;
   background-color: #00a0c1;
   border-color: #00a0c1;
}

.btn-info:focus,
.btn-info:hover,
.btn-info:active {
   background-color: #00a0c1;
   border-color: #00a0c1;
   opacity: 0.9
}

.btn-info:disabled {
   background-color: #00343f;
   border-color: #00343f;
}

.btn-outline-info {
   color: #00a0c1;
   border-color: #00a0c1;
}

.btn-outline-info:focus,
.btn-outline-info:hover,
.btn-outline-info:active {
   color: #fff;
   background-color: #00a0c1;
   border-color: #00a0c1;
}


.btn-warning {
   background-color: #F3994D;
   border-color: #F3994D;
}

.btn-warning:hover {
   background-color: #F3994D;
   border-color: #F3994D;
   opacity: 0.9
}

.btn-outline-warning {
   color: #F3994D;
   border-color: #F3994D;
}

.btn-outline-warning:hover {
   color: #fff;
   background-color: #F3994D;
   border-color: #F3994D;
}

.btn-circle {
   width: 30px;
   height: 30px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #00A0C1;
   color: #00A0C1;
}

.btn-circle-trash {
   width: 30px;
   height: 30px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #EB1C24;
   color: #EB1C24;
}

.btn-circle-trash:hover {
   border: 1px solid #EB1C24;
   color: whitesmoke;
   background-color: #EB1C24;
}


.btn-circle-cancel {
   width: 30px;
   height: 30px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #F3994D;
   color: #F3994D;
}

.btn-circle-cancel:hover {
   border: 1px solid #F3994D;
   color: whitesmoke;
   background-color: #F3994D;
}

.btn-circle-enable {
   width: 30px;
   height: 30px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #00A36C;
   color: #00A36C;
}

.btn-circle-enable:hover {
   border: 1px solid #00A36C;
   color: whitesmoke;
   background-color: #00A36C;
}


.btn-circle-check {
   width: 30px;
   height: 30px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #00A36C;
   color: #00A36C;
}

.btn-circle-check:hover {
   background-color: #00A36C;
   color: whitesmoke;
   border: 1px solid #00A36C;
}

.btn-circle:hover {
   border: 1px solid #00A0C1;
   background-color: #00A0C1;
   color: whitesmoke;
}

.btn-circle:focus {
   border: 1px solid #00A0C1;
   color: #00A0C1;
}

.btn-circle-danger {
   width: 30px;
   height: 30px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #EB1C24;
   color: #EB1C24;
}

.btn-circle-danger:hover {
   border: 1px solid #EB1C24;
   color: #EB1C24;
}

.btn-circle-danger:focus {
   border: 1px solid #EB1C24;
   color: #EB1C24;
}

.bg-blur {
   position: fixed;
   top: 0;
   left: 0;
   z-index: 1040;
   width: 100vw;
   height: 100vh;
   background-color: rgba(0, 0, 0, 0.4);
   backdrop-filter: blur(5px);
}
</style>